/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Hero_BodyInputs */

const en_control_hero_body = /** @type {(inputs: Control_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solve stuck points fast, compare ability choices, plan your build, and find direct answers without digging through a giant wiki.`)
};

const zh_control_hero_body = /** @type {(inputs: Control_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卡在谜题、任务或能力选择？这里提供直接答案、配装规划和流程提示，不用在大型 Wiki 里反复翻找。`)
};

/**
* | output |
* | --- |
* | "Solve stuck points fast, compare ability choices, plan your build, and find direct answers without digging through a giant wiki." |
*
* @param {Control_Hero_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_hero_body = /** @type {((inputs?: Control_Hero_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Hero_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_hero_body(inputs)
	return zh_control_hero_body(inputs)
});
export { control_hero_body as "control.hero.body" }